/**
 * Turkmenistan manat.
 */
export var TMT = {
  code: 'TMT',
  base: 10,
  exponent: 2
};